export const POSITION_CONGRESSMAN = "Congressman";

export const POSITION_AGENCY = "Agency";

export const POSITION_REGIONAL_DIRECTOR = "Regional Director";

export const POSITION_NATIONAL_AGENCY = "National Agency";

export const POSITION_SENATOR = "Senator";

export const POSITION_GOVERNOR = "Governor";

export const POSITION_VICE_GOVERNOR = "Vice Governor";

export const POSITION_MAYOR = "Mayor";

export const POSITION_VICE_MAYOR = "Vice Mayor";

export const POSITION_OTHERS = "Others";

export const selectorOptions = [
  {
    value: 1,
    label: POSITION_CONGRESSMAN,
  },
  {
    value: 2,
    label: POSITION_AGENCY,
  },
  {
    value: 3,
    label: POSITION_REGIONAL_DIRECTOR,
  },
  {
    value: 5,
    label: POSITION_NATIONAL_AGENCY,
  },
  {
    value: 6,
    label: POSITION_SENATOR,
  },
  {
    value: 7,
    label: POSITION_GOVERNOR,
  },
  {
    value: 9,
    label: POSITION_VICE_GOVERNOR,
  },
  {
    value: 8,
    label: POSITION_MAYOR,
  },
  {
    value: 10,
    label: POSITION_VICE_MAYOR,
  },
  {
    value: 11,
    label: POSITION_OTHERS,
  },
];

export const HOUSE_SPEAKER_SELECTOR_OPTIONS = selectorOptions.filter(
  (option) => option.value !== 4
);

// Agency IDs used for filtering specific agency types in the directory view
export const agencyIds = [8, 11, 16, 28, 27];

export const numberIdentifier = [
  "allocations",
  "expenditures",
  "remaining_balance",
];
